import React, {Component} from 'react'
import {Route, Link} from "react-router-dom";
import './TopBar.css';
import logo from '../logo.png';

export default class TopBar extends Component {
  render() {
    return (
      <Route path="/" exact children={({match}) => {
        return (
          <div className={match ? 'top-bar root' : 'top-bar'}>
            <img alt="logo" className="logo" src={logo}/>
            <h1>
              Colors of Twitter
            </h1>
            <div id="links">
              <Route path="/" exact render={() => <Link className="link" to="/about">About</Link>}/>
            </div>
          </div>
        )
      }}/>
    )
  }
}
